import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import EditProvider from "views/Components/EditProvider";
// import { Manager, Target, Popper } from "react-popper";

// @material-ui/core components
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import Grow from "@material-ui/core/Grow";
import Hidden from "@material-ui/core/Hidden";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import InfoIcon from '@material-ui/icons/Info';
import Person from "@material-ui/icons/Person";

// core components
import Button from "components/CustomButtons/Button.js";

import CustomModal from "NewComponents/CustomModal/CustomModal";
import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
import { LoginContext } from "contexts/LoginContext";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import ChangePassword from "views/Components/ChangePassword";
const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const history = useHistory();
  const location = useLocation();
  const { hash, pathname, search } = location;

  const { user, setUser, providerId, setShowTrialAlert, showTrialAlert, userPrivileges } = useContext(LoginContext)
  const [openNotification, setOpenNotification] = React.useState(null);
  const handleClickNotification = (event) => {
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null);
    } else {
      setOpenNotification(event.currentTarget);
    }
  };
  const handleCloseNotification = () => {
    setOpenNotification(null);
  };
  const [openProfile, setOpenProfile] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = React.useState(false);
  const [reset, setReset] = React.useState(false);
  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };

  const handleOpenProfile = (e) => {
    e.preventDefault()
    setOpenProfile(null);
    setShowModal(true);

  };

  const handleOpenChangePasswordModal = (e) => {
    e.preventDefault()
    setOpenProfile(null);
    setShowChangePasswordModal(true);

  };

  const handleCloseEditProvider = () => {
    setShowModal(false);
  }

  const handleCloseChangePasswordModal = () => {
    setShowChangePasswordModal(false);
  }

  const handleCloseProfile = () => {
    setUser(null);
    setOpenProfile(null);
    console.log("log test")
    window.location.href = "/letsStart";
    // history.push("/letsStart")

  };

  const handleDropdownProfile = () => {

    setOpenProfile(null); // This will close the dropdown regardless
  };


  const handleLogout = () => { }
  const classes = useStyles();
  const { rtlActive } = props;
  const searchButton =
    classes.top +
    " " +
    classes.searchButton +
    " " +
    classNames({
      [classes.searchRTL]: rtlActive,
    });
  const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover, {
    [classes.dropdownItemRTL]: rtlActive,
  });
  const wrapper = classNames({
    [classes.wrapperRTL]: rtlActive,
  });
  const managerClasses = classNames({
    [classes.managerClasses]: true,
  });

  return (
    <div className={wrapper}>
      {/* <CustomInput
        rtlActive={rtlActive}
        formControlProps={{
          className: classes.top + " " + classes.search,
        }}
        inputProps={{
          placeholder: rtlActive ? "بحث" : "Search",
          inputProps: {
            "aria-label": rtlActive ? "بحث" : "Search",
            className: classes.searchInput,
          },
        }}
      />
      <Button
        color="white"
        aria-label="edit"
        justIcon
        round
        className={searchButton}
      >
        <Search className={classes.headerLinksSvg + " " + classes.searchIcon} />
      </Button>
      <Button
        color="transparent"
        simple
        aria-label="Dashboard"
        justIcon
        className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
        muiClasses={{
          label: rtlActive ? classes.labelRTL : "",
        }}
      >
        <Dashboard
          className={
            classes.headerLinksSvg +
            " " +
            (rtlActive ? classes.links + " " + classes.linksRTL : classes.links)
          }
        />
        <Hidden mdUp implementation="css">
          <span className={classes.linkText}>
            {rtlActive ? "لوحة القيادة" : "Dashboard"}
          </span>
        </Hidden>
      </Button>
       */}
      {/* <div className={managerClasses}>
        <Button
          color="transparent"
          justIcon
          aria-label="Notifications"
          aria-owns={openNotification ? "notification-menu-list" : null}
          aria-haspopup="true"
          onClick={handleClickNotification}
          className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
          muiClasses={{
            label: rtlActive ? classes.labelRTL : "",
          }}
        >
          <Notifications
            className={
              classes.headerLinksSvg +
              " " +
              (rtlActive
                ? classes.links + " " + classes.linksRTL
                : classes.links)
            }
          />
          <span className={classes.notifications}>5</span>
          <Hidden mdUp implementation="css">
            <span
              onClick={handleClickNotification}
              className={classes.linkText}
            >
              {rtlActive ? "إعلام" : "Notification"}
            </span>
          </Hidden>
        </Button>
        <Popper
          open={Boolean(openNotification)}
          anchorEl={openNotification}
          transition
          disablePortal
          placement="bottom"
          className={classNames({
            [classes.popperClose]: !openNotification,
            [classes.popperResponsive]: true,
            [classes.popperNav]: true,
          })}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id="notification-menu-list"
              style={{ transformOrigin: "0 0 0" }}
            >
              <Paper className={classes.dropdown}>
                <ClickAwayListener onClickAway={handleCloseNotification}>
                  <MenuList role="menu">
                    <MenuItem
                      onClick={handleCloseNotification}
                      className={dropdownItem}
                    >
                      {rtlActive
                        ? "إجلاء أوزار الأسيوي حين بل, كما"
                        : "Mike John responded to your email"}
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      className={dropdownItem}
                    >
                      {rtlActive
                        ? "شعار إعلان الأرضية قد ذلك"
                        : "You have 5 new tasks"}
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      className={dropdownItem}
                    >
                      {rtlActive
                        ? "ثمّة الخاصّة و على. مع جيما"
                        : "You're now friend with Andrew"}
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      className={dropdownItem}
                    >
                      {rtlActive ? "قد علاقة" : "Another Notification"}
                    </MenuItem>
                    <MenuItem
                      onClick={handleCloseNotification}
                      className={dropdownItem}
                    >
                      {rtlActive ? "قد فاتّبع" : "Another One"}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div> */}

      <div className={managerClasses}>
        {
          pathname === "/admin/dashboard" && userPrivileges?.PackageId === 4 &&
          <Button
            color="transparent"
            aria-label="Person"
            justIcon
            aria-owns={openProfile ? "profile-menu-list" : null}
            aria-haspopup="true"
            onClick={() =>
              setShowTrialAlert(!showTrialAlert)}
            className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
            muiClasses={{
              label: rtlActive ? classes.labelRTL : "",
            }}
          >
            <InfoIcon
              className={
                classes.headerLinksSvg +
                " " +
                (rtlActive
                  ? classes.links + " " + classes.linksRTL
                  : classes.links)
              }
            />

          </Button>
        }

        <Button
          color="transparent"
          aria-label="Person"
          justIcon
          aria-owns={openProfile ? "profile-menu-list" : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
          muiClasses={{
            label: rtlActive ? classes.labelRTL : "",
          }}
        >
          <Person
            className={
              classes.headerLinksSvg +
              " " +
              (rtlActive
                ? classes.links + " " + classes.linksRTL
                : classes.links)
            }
          />
          <Hidden mdUp implementation="css">
            <span onClick={handleClickProfile} className={classes.linkText}>
              {rtlActive ? "الملف الشخصي" : "Profile"}
            </span>
          </Hidden>
        </Button>


        <Popper
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          placement="bottom"
          className={classNames({
            [classes.popperClose]: !openProfile,
            [classes.popperResponsive]: true,
            [classes.popperNav]: true,
          })}
        >
          {({ TransitionProps }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list"
              style={{ transformOrigin: "0 0 0" }}
            >
              <Paper className={classes.dropdown}>
                <ClickAwayListener onClickAway={handleDropdownProfile}>
                  <MenuList role="menu">
                    <MenuItem
                      onClick={(e) => handleOpenProfile(e)}
                      className={dropdownItem}
                    >
                      {rtlActive ? "الملف الشخصي" : "Profile"}
                    </MenuItem>
                    <MenuItem
                      onClick={(e) => handleOpenChangePasswordModal(e)}
                      className={dropdownItem}
                    >
                      {rtlActive ? "الخروج" : "Change password"}
                    </MenuItem>
                    {/* <MenuItem
                    onClick={handleCloseProfile}
                    className={dropdownItem}
                  >
                    {/* <MenuItem
                    onClick={handleCloseProfile}
                    className={dropdownItem}
                  >
                    {rtlActive ? "الإعدادات" : "Settings"}
                  </MenuItem> */}
                    {/* <Divider light /> */}
                    {/* <MenuItem 
                    onClick={(e) =>handleOpenProfile(e)}
                    className={dropdownItem}
                  >
                    Preferences
                  </MenuItem> */}
                    <MenuItem
                      onClick={handleCloseProfile}
                      className={dropdownItem}
                    >
                      {rtlActive ? "الخروج" : "Log out"}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}

        </Popper>
      </div>
      {/* Render EditProvider modal only when showEditProvider state is true */}
      {/* {showEditProvider && (
        <EditProvider onClose={() => setShowEditProvider(false)} providerIdEdit={providerId} />
      )} */}
      <CustomModal
        modal={showModal}
        setModal={() => handleCloseEditProvider()}
        padding1={true}
        content={<EditProvider
          afterFinish={() => {
            handleCloseEditProvider();
            // refetch();
          }}
          providerIdEdit={providerId}
        />}
        showOk={false}
        showCancel={false}
        title={"Edit provider"}
        maxWidth="xl"
        onCancelClick={() => handleCloseEditProvider()}
      >
        {/* Render success or error alerts here */}
      </CustomModal>
      <CustomModal
        modal={showChangePasswordModal}
        setModal={() => handleCloseChangePasswordModal()}
        padding1={true}
        content={
          <ChangePassword
            afterFinish={() => {
              handleCloseChangePasswordModal();
              // refetch();
            }}
            isResetFields={() => setReset(reset ? false : true)}
          />
        }
        showOk={false}
        showCancel={false}
        onCancelClick={() => handleCloseChangePasswordModal()}
        title={"Change Password"}
        maxWidth="xs"
      >
      </CustomModal>
    </div >

  );
}

HeaderLinks.propTypes = {
  rtlActive: PropTypes.bool,
};
